$(document).on('click', 'form#multiple_prescribers_confirmation button[type=submit]', function (event) {
  $('#multiple_prescribers_confirmation_modal').modal('hide');
});

$(function () {
  $('.select-all-organizations').on('click', function(){
    $(this).closest('.org_user_select').find('.select2-bootstrap option').prop('selected', true).parent().trigger('change');
  });
});
